const cleanValue = (value) => `${value || ''}`.trim()

export const mapBrandSearchResult = (brand = {}) => {
  const normalizedBrand = brand || {}

  return {
    ...normalizedBrand,
    brand_description: cleanValue(normalizedBrand.brand_description),
    brand_id: cleanValue(normalizedBrand.brand_id),
    brand_name: cleanValue(normalizedBrand.brand_name),
    is_target_owned: Boolean(normalizedBrand.is_target_owned),
  }
}

export const mapBrandSearchResponse = (response = {}) =>
  (response.brands || [])
    .map(mapBrandSearchResult)
    .filter(({ brand_id, brand_name }) => Boolean(brand_id && brand_name))

export const mapUserSearchResult = (user = {}) => {
  const normalizedUser = user || {}

  return {
    name: cleanValue(normalizedUser.name || normalizedUser.display_name),
    login_id: cleanValue(normalizedUser.login_id),
    email: cleanValue(normalizedUser.email || normalizedUser.mail),
    title: cleanValue(normalizedUser.title),
  }
}

export const mapUserSearchResponse = (response = []) =>
  (Array.isArray(response) ? response : [])
    .map(mapUserSearchResult)
    .filter(({ name, login_id, email }) => Boolean(name && login_id && email))
